if (!customElements.get('amare-header-navigation')) {
  class AmareHeaderNavigation extends HTMLElement {
    connectedCallback() {
      this.searchTrigger = this.querySelector('[data-search-trigger]');
      this.searchPanel = this.querySelector('[data-search-panel]');
      this.searchInput = this.querySelector('[data-search-input]');
      this.megaTriggers = [...this.querySelectorAll('[data-mega-trigger]')];
      this.megaPanels = [...this.querySelectorAll('[data-mega-panel]')];

      this.searchTrigger?.addEventListener('click', () => this.toggleSearch());
      this.querySelector('[data-search-close]')?.addEventListener('click', () => this.closeAll());
      this.megaTriggers.forEach((trigger) => {
        const name = trigger.dataset.megaTrigger;
        trigger.addEventListener('mouseenter', () => this.openMega(name));
        trigger.addEventListener('focus', () => this.openMega(name));
        if (trigger.tagName === 'BUTTON') {
          trigger.addEventListener('click', () => this.openMega(name));
        }
      });
      this.querySelectorAll('[data-close-navigation]').forEach((link) => link.addEventListener('click', () => this.closeAll()));
      this.addEventListener('mouseleave', () => this.closeMegas());
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.closeAll();
          this.returnFocus?.focus();
        }
      });
      this.documentClick = (event) => {
        if (!this.contains(event.target)) this.closeAll();
      };
      document.addEventListener('click', this.documentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.documentClick);
    }

    toggleSearch() {
      if (!this.searchPanel?.hidden) {
        this.closeAll();
        return;
      }
      this.closeMegas();
      this.returnFocus = this.searchTrigger;
      this.searchPanel.hidden = false;
      this.searchTrigger?.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => this.searchInput?.focus());
    }

    openMega(name) {
      this.closeSearch();
      this.returnFocus = this.megaTriggers.find((trigger) => trigger.dataset.megaTrigger === name);
      this.megaPanels.forEach((panel) => { panel.hidden = panel.dataset.megaPanel !== name; });
      this.megaTriggers.forEach((trigger) => trigger.setAttribute('aria-expanded', String(trigger.dataset.megaTrigger === name)));
    }

    closeMegas() {
      this.megaPanels?.forEach((panel) => { panel.hidden = true; });
      this.megaTriggers?.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    }

    closeSearch() {
      if (this.searchPanel) this.searchPanel.hidden = true;
      this.searchTrigger?.setAttribute('aria-expanded', 'false');
    }

    closeAll() {
      this.closeMegas();
      this.closeSearch();
    }
  }

  customElements.define('amare-header-navigation', AmareHeaderNavigation);
}
